import { createTheme } from '@mui/material/styles';

import { componentOverrides } from './components';
import { darkPalette, lightPalette } from './palette';
import { darkShadows, lightShadows } from './shadows';
import { typography } from './typography';

export const lightTheme = createTheme({
  palette: lightPalette,
  typography,
  shadows: lightShadows,
  shape: { borderRadius: 5 },
  components: componentOverrides,
});

export const darkTheme = createTheme({
  palette: darkPalette,
  typography,
  shadows: darkShadows,
  shape: { borderRadius: 5 },
  components: {
    ...componentOverrides,
    MuiInput: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&::before': {
            borderBottom: `1px solid ${theme.palette.text.primary}`,
          },
        }),
      },
    },
  },
});
